import { useQuery } from '@tanstack/react-query';
import { eventMonitorApi } from '../api/eventMonitorApi';

/**
 * GET /api/eraf/event-monitor/filters — 필터 카탈로그
 * queryKey: ['event-monitor', 'filters']
 *
 * 30초 stale — 자주 바뀌지 않는 카탈로그 데이터
 */
export function useEventFilters() {
  return useQuery({
    queryKey: ['event-monitor', 'filters'],
    queryFn: () => eventMonitorApi.getFilters(),
    staleTime: 30_000,
  });
}
